export const isVordingborgCustomer = () : string | false => {
    const catalog = window?.localStorage.getItem('catalogs');

    return catalog === 'Vordingborg Kommune Legetøj' || catalog === 'Vordingborg Kommune SKI 50.21' ? "Tilføj til kurv" : false;
}